import { useAuth0 } from "@auth0/auth0-react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import PrintIcon from "@mui/icons-material/Print";
import Paper from "@mui/material/Paper";
import PreSchoolService from "Lib/API/PreSchool";
import { ReactComponent as SortIcon } from "assets/icons/SortIcon.svg";
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from "components/Dialog/index";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import SendLetter from "components/SendLetter/SendLetter";
import SuccessModal from "components/SuccessModal/SuccessModal";
import ClearGroupFilter from "components/clearGroupFilter";
import RightDrawer from "components/drawer";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect, useRef, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useReactToPrint } from "react-to-print";
import {
  displayProductsHandler,
  getFormDataHandler,
} from "utils/formDataHelper";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import ParticipantDetailsTableBody from "./ParticipantDetailsTableBody";
import ParticipantDrawer from "./ParticipantDrawer/ParticipantDrawer";
import { ButtonContainer } from "./Theme";
import FinanceDrawer from "pages/NewFinance/Drawer";
import { useApiAction, useFetchData } from "hook/useFetchData";
import FinanceService from "Lib/API/Finance/index";
import ChargeLoader from "./ChargeLoader";

const ParticipantDetailsTable = ({
  getFormParticipants,
  sorting,
  setSorting,
  participantsPage,
  setParticipantsPage,
  count,
  rows,
  loading,
  onSharePaymentLinkClick,
  handleInputChange,
  searchValue,
  formId,
  onSharePaymentLinkMultipleClick,
  participantGroupId,
}) => {
  const componentRef = useRef();
  const [check, setCheck] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const styleButtons = {
    color: "#454758",
    fontSize: "14px",
    fontWeight: "400",
  };
  const { getAccessTokenSilently } = useAuth0();
  const [exportType, setExportType] = useState("");
  const [csvData, setExportData] = React.useState([]);
  const [chargeModal, setChargeModal] = useState(false);
  const [openLetterModal, setOpenLetterModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [sendLetterLoading, setSendLetterLoading] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  // hooks
  const { execute: reSentInvitation, loading: reSentLoading } = useApiAction(
    (token, body) => PreSchoolService.resendFormInvitation(token, body)
  );

  const {
    data: chargeData,
    loading: chargeLoading,
    fetchData,
  } = useFetchData(FinanceService.getAllTransactionsEnhance);

  const getExportFileName = () => {
    return check?.[0]?.onlineForm?.formName
      ? `${check?.[0]?.onlineForm?.formName}.xlsx`
      : `Participants.xlsx`;
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: getExportFileName(),
  });
  const HeaderTitles = [
    {
      label: "ACCOUNT NAME",
      value: "accountName",
      sortable: true,
    },
    {
      label: "FIRST NAME",
      value: "firstName",
      sortable: true,
    },
    {
      label: "LAST NAME",
      value: "lastName",
      sortable: true,
    },
    {
      label: "EMAIL",
      value: "email",
      sortable: false,
    },
    {
      label: "SUBMISSION DATE",
      value: "submitDate",
      sortable: true,
    },
    {
      label: !rows?.[0]?.onlineForm?.freeForm ? "STATUS" : "",
      value: "registrationStatus",
      sortable: false,
    },
    {
      label: !rows?.[0]?.onlineForm?.freeForm ? "TOTAL PAID" : "",
      value: "totalPaid",
      sortable: false,
    },
  ];
  const columns_for_header = [
    {
      id: "accountName",
      displayName: "Account Name",
      headerName: "Account Name",
      field: "accountName",
      flex: 1,
    },
    {
      id: "accountID",
      displayName: "Account ID",
      headerName: "Account ID",
      field: "accountID",
      flex: 1,
    },
    {
      id: "firstName",
      displayName: "First Name",
      headerName: "First Name",
      field: "firstName",
      flex: 1,
    },
    {
      id: "lastName",
      displayName: "Last Name",
      headerName: "Last Name",
      field: "lastName",
      flex: 1,
    },
    {
      id: "email",
      displayName: "Email",
      headerName: "Email",
      field: "email",
      flex: 1,
    },
    {
      id: "sendDate",
      displayName: "Send Date",
      headerName: "sendDate",
      field: "sendDate",
      flex: 1,
    },
    {
      id: "submissionDate",
      displayName: "Submission Date",
      headerName: "Submission Date",
      field: "submissionDate",
      flex: 1,
    },
    {
      id: "Status",
      displayName: "Status",
      headerName: "Status",
      field: "Status",
      flex: 1,
    },
    {
      id: "total",
      displayName: "Total Paid",
      headerName: "Total Paid",
      field: "total",
      flex: 1,
    },
  ];

  const handleSortChange = (name) => {
    setSorting((prev) => ({
      ...prev,
      sort: {
        [name]: prev.sort[name] === 1 ? -1 : 1,
      },
    }));
  };
  const onCheckboxChange = (e, row) => {
    setCheckAll(false);
    const { checked } = e.target;
    if (!checked) {
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item._id !== row._id);
        return [...checkClone];
      });
      return;
    }
    setCheck((prev) => [...prev, row]);
  };
  const onCheckboxAllChange = (e) => {
    const items = rows;
    setCheckAll(e.target.checked);
    if (!e.target.checked) {
      return setCheck([]);
    }
    const allChecked = [...check, ...items].filter(
      (item, index, self) => index === self.findIndex((i) => i._id === item._id)
    );
    setCheck(allChecked);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getFormParticipants();
    }, 200);

    return () => clearTimeout(timer); // cleanup on dependency change/unmount
  }, [refresh, sorting, participantGroupId]);

  const excelSheet = () => {
    const arr = [];
    if (csvData?.length > 0) {
      csvData.map((item) => {
        const data = {
          ["Account Name"]: item?.accountName,
          ["Account ID"]: item?.account?.account_id,
          ["First Name"]: item?.firstName,
          ["Last Name"]: item?.lastName,
          ["Email"]: item?.contact?.email_address,
          ["Sent Date"]: formatDate({
            date: item?.sendDate,
            formatType: "defaultWithUTC",
          }),
          ["Submission"]: formatDate({
            date: item?.submitDate,
            formatType: "defaultWithUTC",
          }),
          ["Housing Tags"]: item?.housingTags?.join(", "),
          ["Status"]: item?.status,
          ["Total paid"]: `${numberFormat({
            number: item?.totalPaid,
            decimal: 2,
            style: "currency",
          })}`,
          ...getFormDataHandler(
            item?.onlineForm?.form?.task_data,
            item?.formData
          ),
          ...displayProductsHandler(item?.products),
        };
        arr.push(data);
      });
    }
    return arr;
  };
  const generateExcel = () => {
    let res = excelSheet();
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, getExportFileName());
  };

  const downloadExcel = () => {
    getExportData("excel");
  };
  const getExportData = async (value) => {
    const token = await getAccessTokenSilently();
    const ides = checkAll
      ? []
      : check.map((item) => {
          return item._id;
        });
    const body = { formId: formId, participantsIds: ides };
    PreSchoolService.exportForMember(token, body)
      .then((res) => {
        setExportData(res?.payload?.data);
        checkAll && setCheck(res?.payload?.data);
        setExportType(value);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (exportType == "print") {
      handlePrint();
    } else if (exportType == "excel") {
      generateExcel();
    }
    setExportType("");
  }, [exportType]);
  let customCsvData = [];
  let myData =
    csvData?.length !== 0 &&
    csvData?.map((item) => {
      const data = {
        accountName: item?.accountName,
        accountID: item?.account?.account_id,
        firstName: item?.firstName,
        lastName: item?.lastName,
        email: item?.contact?.email_address,
        sendData: formatDate({
          date: item?.sendDate,
          formatType: "defaultWithUTC",
        }),
        submissionDate: formatDate({
          date: item?.submitDate,
          formatType: "defaultWithUTC",
        }),
        status: item?.status,
        total: `${numberFormat({
          number: item?.totalPaid,
          decimal: 2,
          style: "currency",
        })}`,
      };
      customCsvData.push(data);
    });
  const handleSendLetter = async (templateData) => {
    setSendLetterLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      participantsIds: checkAll ? undefined : check.map((item) => item._id),
      formsIds: checkAll ? [formId] : undefined,
      ...templateData,
    };

    PreSchoolService.sendFormParticipantLetter(token, bodyData)
      .then((response) => {
        setOpenSuccessModal(true);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setSendLetterLoading(false);
        setOpenLetterModal(false);
      });
  };

  const closeModal = () => setConfirmClose(true);
  const closeModalCharge = () => setChargeModal(false);

  const openModalCharge = (data) => {
    fetchData(1, 30, {
      search: data,
      filter: {
        hidden: true,
      },
    });
    setChargeModal(true);
  };

  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenDrawer(false);
  };

  const handleSentInvite = async () => {
    try {
      const res = await reSentInvitation({
        participantsIds: checkAll ? [] : check?.map((item) => item._id),
        formId: formId,
      });
      toastr.success("Success", "Resend invitation successfully!");
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Something went wrong!");
    }
  };

  const isStatusSend = check?.some((item) => item?.status === "sent");

  return (
    <div className="w-100">
      <div className={"family-table-container pl-7 pr-6 pt-3 pb-22"}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "18px",
            justifyContent: "space-between",
          }}
          className="header__options"
        >
          <div
            className="d-flex align-items-center"
            style={{
              gap: "15px",
            }}
          >
            <span className="finance-filter-serach-bar ml-5">
              <SearchComp
                value={searchValue}
                setSearchText={handleInputChange}
                placeholder="Search"
                style={{ width: "20.5rem", backgroundColor: "#fff" }}
              />
            </span>
            {participantGroupId && (
              <ClearGroupFilter text="Filtered By Group" />
            )}
          </div>
          {check?.length > 0 && (
            <div className="new-class mt-4">
              <MyButton
                type="secondary"
                content={
                  <ButtonContainer>
                    <FileDownloadIcon style={{ height: "20px" }} />
                    <a style={styleButtons}>Export</a>
                  </ButtonContainer>
                }
                style={{
                  background: "#F4F6F9",
                  color: "#2555EF",
                  border: "none",
                  marginRight: "1rem",
                }}
                onClick={downloadExcel}
              />
              <MyButton
                type="secondary"
                onClick={() => getExportData("print")}
                content={
                  <ButtonContainer>
                    <PrintIcon style={{ height: "20px" }} />
                    <a style={styleButtons}>Print</a>
                  </ButtonContainer>
                }
                style={{
                  background: "#F4F6F9",
                  color: "#2555EF",
                  border: "none",
                  marginRight: "1rem",
                }}
              />
              <span className="button-line" />
              <MyButton
                onClick={handleSentInvite}
                disabled={reSentLoading || !isStatusSend}
                type="secondary"
                content={
                  <ButtonContainer>
                    <ForwardToInboxIcon style={{ height: "20px" }} />
                    Send Invitation: {checkAll ? count : check.length}
                  </ButtonContainer>
                }
                style={{
                  background: "#D3DDFC",
                  color: "#2555EF",
                  border: "none",
                  marginRight: "1rem",
                  padding: "0px 25px",
                  opacity: isStatusSend ? 1 : 0.3,
                }}
              />
            </div>
          )}
        </div>

        <div className="home-table-container mt-0 no-box-shadow">
          <TableContainer component={Paper} className="scroll-table">
            <Table class="main-table" aria-label="collapsible table">
              <TableHead className="charges-table sticky-table-header">
                <TableRow>
                  <TableCell className="charged-value-check-box" align="left">
                    <CheckBox
                      onChange={(e) => {
                        onCheckboxAllChange(e);
                      }}
                      text={""}
                      checked={checkAll}
                    />
                  </TableCell>
                  {HeaderTitles.map((Item) => (
                    <TableCell className="charged-value" align="left">
                      {Item?.label}
                      {Item?.sortable && (
                        <IconButton
                          onClick={() => handleSortChange(Item?.value)}
                        >
                          <SortIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  ))}
                  <TableCell
                    className="empty-head sticky-header-column"
                    align="left"
                  />
                </TableRow>
              </TableHead>
              <TableBody className="tran-table-body">
                <ParticipantDetailsTableBody
                  rows={rows}
                  setOpenDrawer={setOpenDrawer}
                  setDrawerData={setDrawerData}
                  loading={loading}
                  formId={formId}
                  refresh={refresh}
                  setRefresh={setRefresh}
                  onSharePaymentLinkClick={onSharePaymentLinkClick}
                  onCheckboxChange={onCheckboxChange}
                  check={check}
                  checkAll={checkAll}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <div className="pagination-custom mt-20">
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={participantsPage}
              onChange={(event, value) => {
                setParticipantsPage(value);
                getFormParticipants(value);
              }}
            />
          </div>
          <div className="d-none">
            <div id="componentRef" ref={componentRef}>
              <table style={{ padding: 10, margin: 10 }}>
                <thead>
                  {columns_for_header?.map((column, index) => (
                    <th
                      style={{ border: "1px solid", textAlign: "center" }}
                      key={index}
                    >
                      {column?.headerName}
                    </th>
                  ))}
                </thead>
                <tbody>
                  {customCsvData?.map((item, index) => {
                    const d = {
                      ["Account Name"]: item?.accountName,
                      ["Account ID"]: item?.accountID,
                      ["First Name"]: item?.firstName,
                      ["Last Name"]: item?.lastName,
                      ["Email"]: item?.email,
                      ["Send Date"]: item?.sendData,
                      ["Submission Date"]: item?.submissionDate,
                      ["Status"]: item?.status,
                      ["Total Paid"]: item?.total,
                    };
                    return (
                      <tr key={index}>
                        {Object?.values(d)?.map((objectValue, index) => (
                          <td
                            style={{
                              border: "1px solid",
                              padding: 5,
                            }}
                            key={index}
                          >
                            {objectValue}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <RightDrawer open={openDrawer} onClose={closeModal}>
          <ParticipantDrawer
            drawerData={drawerData}
            closeModal={() => setOpenDrawer(false)}
            onSharePaymentLinkClick={onSharePaymentLinkClick}
            getFormParticipants={getFormParticipants}
            openModalCharge={openModalCharge}
          />
        </RightDrawer>
        <RightDrawer open={!!chargeModal} onClose={closeModalCharge}>
          <div className="finance-drawer">
            {chargeLoading ? (
              <ChargeLoader />
            ) : (
              <FinanceDrawer
                data={chargeData?.payload?.data?.[0] ?? {}}
                onReversalClick={() => {}}
              />
            )}
          </div>
        </RightDrawer>
        <Dialog
          open={openLetterModal}
          onClose={() => {
            setOpenLetterModal(false);
            setCheck([]);
            
          }}
            disableEnforceFocus
  disableAutoFocus
  disableRestoreFocus
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <SendLetter
            closeModal={() => {
              setOpenLetterModal(false);
            }}
            initialEmails={check?.length && check.map((item) => item?.email)}
            isMultiple={check?.length > 1}
            handleSendLetter={handleSendLetter}
            sendLetterLoading={sendLetterLoading}
            type="form"
          />
        </Dialog>
        <Dialog
          open={openSuccessModal}
          onClose={() => {
            setOpenSuccessModal(false);
          }}
          PaperProps={{
            style: {
              width: "800px",
              height: "400px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <SuccessModal
            title="Successfully Sent"
            description={`The total number of recipients is ${check.length}`}
            btnText="Done"
            btnAction={() => {
              setOpenSuccessModal(false);
            }}
            closeModal={() => {
              setOpenSuccessModal(false);
            }}
          />
        </Dialog>
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </div>
  );
};

export default ParticipantDetailsTable;
